export const createArray = (length: number) =>
  Array.from({ length }, (_, index) => index);
